import {
  APPOINTMENT_STATUS_OPTIONS,
  ROW_HEIGHT,
} from "@/constants/appointments/appointments-constants";
import {
  Popover,
  PopoverContent,
  PopoverAnchor,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import type { AppointmentStatus } from "@/types/appointments/api-types/appointment-types";

interface EditAppointmentPopoverProps {
  rowIndex: number;
  clientName: string;
  timeString: string;
  status: AppointmentStatus;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onEditAppointmentClick: () => void;
}

const statusLabel = (status: AppointmentStatus): string =>
  APPOINTMENT_STATUS_OPTIONS.find((option) => option.value === status)
    ?.label ?? status;

export function EditAppointmentPopover({
  rowIndex,
  clientName,
  timeString,
  status,
  open,
  onOpenChange,
  onEditAppointmentClick,
}: EditAppointmentPopoverProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverAnchor
        className="absolute left-0 right-0 pointer-events-none"
        style={{
          top: `${rowIndex * ROW_HEIGHT}px`,
          height: `${ROW_HEIGHT}px`,
        }}
      />
      <PopoverContent className="w-auto p-3" align="center">
        <div className="flex flex-col gap-2 min-w-40">
          <div className="text-center">
            <p className="text-sm font-medium">{clientName}</p>
            <p className="text-xs text-muted-foreground">
              {timeString}
              <span className="px-1.5">·</span>
              {statusLabel(status)}
            </p>
          </div>
          <Button
            type="button"
            size="sm"
            onClick={onEditAppointmentClick}
            className="w-full"
          >
            Edit Appointment
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
